import { storage } from "@/CommonDP/utils";

export function getlocalItem(key) {
  return JSON.parse(storage.get(key));
}
// 是否策划文档目录
export function getCatalogToken() {
  return storage.get("catalogInit") || '0';
}

export function setCatalogToken(token) {
  return storage.set("catalogInit", token);
}
// 是否为试用企业  项目不用
export function getIsTrial() {
  return storage.get("isTrial");
}

export function setIsTrial(data) {
  return storage.set("isTrial", data);
}

// 企业id
export function getEnterpriseId() {
  return storage.get("enterpriseId");
}

export function setEnterpriseId(data) {
  return storage.set("enterpriseId", data);
}

// 用户信息
export function getUserInfo() {
  return storage.get("userInfo");
}

export function setUserInfo(data) {
  return storage.set("userInfo", data);
}

// 企业状态
export function getUnauthorized() {
  return storage.get("unauthorized");
}

export function setUnauthorized(data) {
  return storage.set("unauthorized", data);
}
